import emojiMap from 'simple-emoji-map';
export default emojiMap;